import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Logo1 from './assets/logo_tdsb.png';
import Logo2 from './assets/logo_epsb.png';
import Logo3 from './assets/logo_tcdsb.png';
import Logo4 from './assets/logo_peel.png';
import Logo5 from './assets/logo_sd36.png';
import Logo6 from './assets/logo_dpdsb.png';
import Logo7 from './assets/logo_csfs.png';
import Logo8 from './assets/logo_cspne.png';

import './styles/partners.scss';

export default class Partners extends Component {

  render() {
    const partners = this.props.resource.home.partners;
    return (
      <div className="partners-container">
        <div className="partners-container__logos">
          <div className="partners-container__logos__logo">
            <img className="partners-container__logos__logo__image" src={Logo1} alt={partners.tdsb} />
          </div>
          <div className="partners-container__logos__vertical-divider" />
          <div className="partners-container__logos__logo">
            <img className="partners-container__logos__logo__image" src={Logo2} alt={partners.epsd} />
          </div>
          <div className="partners-container__logos__vertical-divider" />
          <div className="partners-container__logos__logo">
            <img className="partners-container__logos__logo__image" src={Logo3} alt={partners.tcdsb} />
          </div>
          <div className="partners-container__logos__vertical-divider" />
          <div className="partners-container__logos__logo">
            <img className="partners-container__logos__logo__image" src={Logo4} alt={partners.peel} />
          </div>
          <div className="partners-container__logos__horizontal-divider" />
          <div className="partners-container__logos__logo">
            <img className="partners-container__logos__logo__image" src={Logo5} alt={partners.ss} />
          </div>
          <div className="partners-container__logos__vertical-divider" />
          <div className="partners-container__logos__logo">
            <img className="partners-container__logos__logo__image" src={Logo6} alt={partners.dpcdsb} />
          </div>
          <div className="partners-container__logos__vertical-divider" />
          <div className="partners-container__logos__logo">
            <img className="partners-container__logos__logo__image" src={Logo7} alt={partners.csfs} />
          </div>
          <div className="partners-container__logos__vertical-divider" />
          <div className="partners-container__logos__logo">
            <img className="partners-container__logos__logo__image" src={Logo8} alt={partners.cspne} />
          </div>
        </div>
        <div className="partners-container__more-partners">
          +<br />{partners.more}
        </div>
      </div>
    );
  }
}

Partners.propTypes = {
  resource: PropTypes.object
};
